import * as React from 'react'
import { createPortal } from 'react-dom'
import {PhotoSwipe} from 'react-photoswipe'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import isBrowser from 'semantic-ui-react/src/lib/isBrowser'

const options = {
  closeOnScroll: false,
  history: false,
}

const Gallery = (props) => {
  return (
    isBrowser() &&
    props.isOpen &&
    createPortal(
      <PhotoSwipe {...props} options={options} />,
      document.getElementById('gallery-modal'))
  )
}

export default Gallery
